import { StepData } from '@/lib/Steppers';

export enum CREATE_DATA_SOURCE_CODE {
  SOURCE_DETAILS,
  TRACK_ACTIVITY,
  INSTALL_SNIPPET,
  CHECK_INSTALLATION,
  INSTALLATION_SUCCESS,
}

export const CREATE_DATA_SOURCE_CODE_STEPS: ReadonlyArray<StepData<number>> = [
  {
    id: CREATE_DATA_SOURCE_CODE.SOURCE_DETAILS,
    title: 'data_source_edit:code.steps.source_details',
  },
  {
    id: CREATE_DATA_SOURCE_CODE.TRACK_ACTIVITY,
    title: 'data_source_edit:code.steps.track_events',
  },
  {
    id: CREATE_DATA_SOURCE_CODE.INSTALL_SNIPPET,
    title: 'data_source_edit:code.steps.install_snippet',
  },
  {
    id: CREATE_DATA_SOURCE_CODE.CHECK_INSTALLATION,
    title: 'data_source_edit:code.steps.check_installation',
  },
  {
    id: CREATE_DATA_SOURCE_CODE.INSTALLATION_SUCCESS,
    title: 'data_source_edit:code.steps.installation_success',
  },
];
